import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "pad", "level"];
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './styles.sass';
var ShadowBox = function ShadowBox(_ref) {
  var className = _ref.className,
    children = _ref.children,
    pad = _ref.pad,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 1 : _ref$level,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('shadow-box', "shadow-box--level-".concat(level), pad && 'shadow-box--pad', className)
  }, props), children);
};
ShadowBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  pad: PropTypes.bool,
  level: PropTypes.number
};
export default ShadowBox;
//# sourceMappingURL=index.js.map
